import { useLoadCart } from '@features/cart';
import { useLoadCommonSettings, useLoadWebsettings } from '@features/common';
import { useInterceptors } from '@shared/hooks';
// import { useLoadUser } from 'library/hooks/user';
import { useUser } from '@shared/hooks/index.ts';
import { useModulesQuery } from '@src/api/api-hooks/common/useModulesQuery.ts';
import { useLoadNotifications } from 'library/hooks/notifications';

export const Loader = () => {
  useUser();
  useModulesQuery();
  useLoadCart();
  useLoadWebsettings();
  useLoadNotifications();
  useLoadCommonSettings();
  useInterceptors();
  return <></>;
};
